import { ShippingProviderType, type SwitchShipmentProviderRequest } from '@/infrastructure/OMSClient';

const storageKey = (orderId: string) => `oms:shipment-switch:v1:${orderId}`;

export function readShipmentSwitchDraft(
  orderId: string,
  sourceProviderOrderId: string,
): SwitchShipmentProviderRequest | null {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(storageKey(orderId)) ?? 'null');
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }
    const draft = parsed as Partial<SwitchShipmentProviderRequest>;
    if (
      draft.expectedSourceProviderOrderId !== sourceProviderOrderId ||
      !Object.values(ShippingProviderType).includes(draft.targetProvider as ShippingProviderType) ||
      typeof draft.idempotencyKey !== 'string' ||
      !draft.idempotencyKey ||
      typeof draft.reason !== 'string'
    ) {
      return null;
    }
    return {
      targetProvider: draft.targetProvider!,
      expectedSourceProviderOrderId: sourceProviderOrderId,
      idempotencyKey: draft.idempotencyKey,
      reason: draft.reason,
    };
  } catch {
    return null;
  }
}

export function saveShipmentSwitchDraft(orderId: string, request: SwitchShipmentProviderRequest): void {
  // Save before dispatch. If storage is unavailable, fail closed rather than lose an uncertain operation identity.
  localStorage.setItem(storageKey(orderId), JSON.stringify(request));
}

export function clearShipmentSwitchDraft(orderId: string): void {
  localStorage.removeItem(storageKey(orderId));
}
